// import Vue from 'vue'
import axios from "axios";
import router from "../router";
import { VueAxios } from "./axios";
import vm from "../main";
const service = axios.create({});

axios.defaults.headers.post["responseType"] = "blob";

const err = (error) => {
    switch (error.response && error.response.status) {
        case 400:
            console.error(error.response.status, error.message);
            console.warn("Nothing to display", "Data Not Found");
            break;

        case 401: // authentication error, logout the user
            console.warn("Please login again", "Session Expired");
            // localStorage.removeItem('token');
            router.push("/");
            break;
        case "Network Error": // authentication error, logout the user
            // localStorage.removeItem('token');
            router.push("/");
            break;
        default:
            console.error("Server Error");
    }
    return Promise.reject(error);
};

// request interceptor
service.interceptors.request.use((config) => {
    const token = vm.$ls.get("Authorization");
    if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
}, err);

// response interceptor
service.interceptors.response.use((response) => {
    let res;
    res = response.config.responseType == "blob" ? response : response.data;
    return res;
}, err);
const installer = {
    vm: {},
    install(Vue) {
        Vue.use(VueAxios, service);
    },
};

export { installer as VueAxios, service as axios };